export default "__VITE_ASSET__C2Q2rl1m__"